@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {
  display: block;

  .jui-control {
    @include form-control-mixins.jui-control-base;

    > * {
      flex: 1 100%;
    }

    &__label {
      @include form-control-mixins.form-control-label;

      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }

      &--narrower {
        @include form-control-mixins.form-control-label-narrower;
      }
    }

    &__label-text {
      width: 100%;
    }

    &__error {
      @include form-control-mixins.form-control-error;
    }

    &__help {
      @include form-control-mixins.form-control-help--fieldset;
    }

    &__tooltip {
      @include form-control-mixins.form-control-tooltip;

      &--input-lg {
        @include form-control-mixins.form-control-tooltip;
      }
    }
    &__tooltip-text {
      @include form-control-mixins.form-control-tooltip-text;

      &--left {
        @include form-control-mixins.form-control-tooltip-text-left;
      }

      &--left-bottom {
        @include form-control-mixins.form-control-tooltip-text-left-bottom;
      }
    }

    &__tooltip-text::before {
      @include form-control-mixins.form-control-tooltip-text-before;
    }

    &__tooltip-text--left::before {
      @include form-control-mixins.form-control-tooltip-text-left-before;
    }

    &__tooltip-text--left-bottom::before {
      @include form-control-mixins.form-control-tooltip-text-left-bottom-before;
    }

    &__tooltip:hover .jui-control__tooltip-text {
      @include form-control-mixins.tooltip-hover;
    }
  }

  .jui-chipset {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--jds-space-xs);
    padding: var(--jds-space-xs) 0;
    border-bottom: 2px solid transparent;

    &--lg {
      gap: var(--jds-space-sm);
    }

    &--md {
      gap: var(--jds-space-sm);
    }

    &--invalid {
      border-color: var(--jui-danger-color);
    }

    &--vertical {
      flex-direction: column;
      align-items: start;
    }
  }

}

